import { Redirect } from 'expo-router';
import { useAuthStore } from '../src/stores/authStore';
import { View, ActivityIndicator } from 'react-native';
import { useTheme } from '../src/utils/theme';
import { needsInitialSetup } from '../src/utils/onboarding';

export default function Index() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const user = useAuthStore((s) => s.user);
  const { colors } = useTheme();

  // Wait for session to restore before deciding where to go
  if (isLoading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: colors.background }}>
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    );
  }

  if (!isAuthenticated) {
    return <Redirect href="/(auth)/phone" />;
  }

  return <Redirect href={needsInitialSetup(user) ? '/(auth)/setup' : '/(tabs)/chat'} />;
}
